// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const corkOak = defineModel({
  id: "cork-oak",
  batchId: "future",
  name: "Cork oak",
  tags: ["scenery","cork","oak","low-poly","age-of-mcp","future"],
  summary: "A cork oak with its bark stripped. Cork for stoppers, floats, insulation and soles.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.07, 0.1, 0.3, 7), color: "#b4543a", position: [0, 0.15, 0] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.07, 0.22, 7), color: "#8a6a4a", position: [0, 0.4, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.24, 0), color: "#5f7a3a", position: [0, 0.56, 0], scale: [1.3, 0.8, 1.3] },
      { geometry: new THREE.IcosahedronGeometry(0.16, 0), color: "#6f8a44", position: [-0.12, 0.66, 0.08], scale: [1.1, 0.8, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.14, 0), color: "#5f7a3a", position: [-0.1, 0.62, -0.12], scale: [1.1, 0.8, 1.1] },
    ] },
    { id: "variant-1", label: "Variant 2", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.07, 0.1, 0.3, 7), color: "#b4543a", position: [0, 0.15, 0] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.07, 0.22, 7), color: "#8a6a4a", position: [0, 0.4, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.24, 0), color: "#5f7a3a", position: [0, 0.56, 0], scale: [1.3, 0.8, 1.3] },
      { geometry: new THREE.IcosahedronGeometry(0.16, 0), color: "#6f8a44", position: [0.12, 0.66, 0.08], scale: [1.1, 0.8, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.14, 0), color: "#5f7a3a", position: [-0.1, 0.62, -0.12], scale: [1.1, 0.8, 1.1] },
    ] },
  ],
  animations: [],
});
